import { designService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';

import { truckDriversLoaded } from '../store/truckDriversSlice';
import { AsyncThunkActionVoid } from './thunkActions';

export function loadTruckDrivers(): AsyncThunkActionVoid {
  return async function loadTruckDriversThunkAction(dispatch) {
    try {
      const truckDrivers = await designService.truckDrivers.getAll();
      dispatch(truckDriversLoaded(truckDrivers));
    } catch (exception) {
      dispatch(enqueueError('Loading truck drivers failed. Try refreshing or contact Paragon support.'));
      console.error(exception);
    }
  };
}
